<div
  class="dashboard-widget group"
  [ngClass]="editMode() ? 'border-2 border-dashed border-primary-color' : ''"
>
  <div
    class="widget-header flex flex-row items-center px-1 h-6 border-solid border-t-[5px] group-hover:bg-layout-sidenav group-hover:dark:bg-layout-dark-sidenav"
    [ngClass]="editMode() ? 'cursor-move z-50' : 'z-30'"
    [style.borderTopColor]="widget.color"
    >
    @if (editMode()) {
      <button
        mat-icon-button
        #menuTrigger="matMenuTrigger"
        [matMenuTriggerFor]="menu"
        (click)="$event.stopPropagation()"
        >
        <fa-icon [icon]="faEllipsisVertical">more_vert</fa-icon>
      </button>
    }

    <mat-menu #menu="matMenu" class="widget-menu">
      @if (hasUserPermission()) {
        <button
          mat-menu-item
          (click)="editWidget($event); $event.stopPropagation()"
          >
          <fa-icon [icon]="faEdit"></fa-icon>
          <span>{{ 'common.EDIT' | transloco }}</span>
        </button>
      }

      <button
        mat-menu-item
        (click)="removeWidget($event); $event.stopPropagation()"
        >
        <fa-icon [icon]="faTimes"></fa-icon>
        <span>{{ 'common.REMOVE' | transloco }}</span>
      </button>

      @if (hasUserPermission()) {
        <button
          mat-menu-item
          (click)="deleteWidget($event); $event.stopPropagation()"
          >
          <fa-icon [icon]="faTimes"></fa-icon>
          <span>{{ 'common.DELETE' | transloco }}</span>
        </button>
      }
    </mat-menu>

    <span class="pl-2 name title">{{ title() }}</span>

    <div class="flex flex-grow"></div>
    @if (hasUserPermission() && editMode()) {
      <button
        class="hidden mr-2 settings group-hover:inline-flex"
        mat-icon-button
        (click)="openSettings($event)"
        >
        <fa-icon [icon]="faGear"></fa-icon>
      </button>
    }
  </div>

  <!-- widget dynamic part-->
  <div class="select-none widget-body">
    <dashboard-widget-type-content></dashboard-widget-type-content>
  </div>
</div>
